import clx from "classnames";
import Icon from "./Icon";

export default function Spinner({ loading = true, className = "w-4 h-4 text-gray-500" }) {
  return loading ? <Icon code="spinner" className={clx(className, "animate-spin")} /> : <></>;
}
